<template>
  <select
    class="border-bg-lightest bg-tint-less hover:bg-tint p-3 max-md:pl-2 pr-6 appearance-none rounded-none w-full h-full"
    @input="$emit(`input`, $event.target.value)"
  >
    <option value="">{{ defaultOption }}</option>
    <option
      v-for="(item, index) in collection"
      :disabled="disabledIf(index)"
      :selected="selectedIf(item)"
      :key="index"
      :value="item"
      >{{ displayFilter(item) }}</option
    >
  </select>
</template>

<script>
export default {
  props: {
    collection: {
      type: Array,
      default: () => [],
    },
    defaultOption: {
      type: String,
      default: `Select`,
    },
    displayFilter: {
      type: Function,
      default: label => label,
    },
    name: {
      type: String,
      required: true,
    },
    disabledIf: {
      type: Function,
      default: () => false,
    },
    selectedIf: {
      type: Function,
      default: () => false,
    },
  },
}
</script>
